import { render, staticRenderFns } from "./ResourceSettings.vue?vue&type=template&id=72b6e9f7&scoped=true"
import script from "./ResourceSettings.vue?vue&type=script&lang=js"
export * from "./ResourceSettings.vue?vue&type=script&lang=js"
import style0 from "./ResourceSettings.vue?vue&type=style&index=0&id=72b6e9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6e9f7",
  null
  
)

export default component.exports